import { cva, type VariantProps } from 'class-variance-authority'

export const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-lg font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary disabled:opacity-50 disabled:pointer-events-none active:scale-[0.98]',
  {
    variants: {
      variant: {
        default:
          'bg-primary text-white hover:bg-primary-dark border border-transparent shadow-sm hover:shadow-md',
        secondary:
          'bg-secondary text-white hover:bg-secondary-dark border border-transparent shadow-sm hover:shadow-md',
        outline:
          'border border-primary text-primary bg-transparent hover:bg-primary/10 hover:border-primary-dark',
        outlineSecondary:
          'border border-secondary text-secondary bg-transparent hover:bg-secondary/10 hover:border-secondary-dark',
        ghost: 'bg-transparent text-primary hover:bg-primary/10',
        ghostNeutral: 'bg-transparent text-gray-700 hover:bg-muted/50',
        subtle: 'bg-muted/30 text-gray-800 hover:bg-muted/50 border border-gray-200',
        ghostSecondary: 'bg-transparent text-secondary hover:bg-secondary/10',
        destructive:
          'bg-destructive text-white hover:bg-destructive-dark shadow-sm hover:shadow-md',
        success: 'bg-primary text-white hover:bg-primary-dark shadow-sm hover:shadow-md',
        warning: 'bg-[#FFB800] text-white hover:bg-[#e6a700] shadow-sm hover:shadow-md',
        info: 'bg-secondary text-white hover:bg-secondary-dark shadow-sm hover:shadow-md',
      },
      size: {
        default: 'h-10 py-2 px-4 text-sm 3xl:h-12 3xl:px-6 3xl:text-base',
        sm: 'h-8 px-3 text-xs 3xl:h-10 3xl:px-4 3xl:text-sm',
        lg: 'h-12 px-8 text-base 3xl:h-14 3xl:px-10 3xl:text-lg',
        icon: 'h-10 w-10 3xl:h-12 3xl:w-12',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
)

export type ButtonVariantProps = VariantProps<typeof buttonVariants>
